import ajax from '@/lib/ajax';
import { VuexModule, Module, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store';
import { AppModule } from '@/store/modules/app';
import KBContentList from '@/models/KnowledgeBase/KBContentList';
import KBSearchResultDto from '@/models/KnowledgeBase/KBSearchResultDto';

export interface ISysKBContentListState {
  loading: boolean;
  contentList: KBContentList | null;
  loadingSearch: boolean;
  searchResults: KBSearchResultDto | null;
}

@Module({ dynamic: true, store, name: 'SysKBContentList', namespaced: true })
class SysKBContentList extends VuexModule implements ISysKBContentListState {

  public loading = false;
  public contentList: KBContentList | null = null;
  public loadingSearch = false;
  public searchResults: KBSearchResultDto | null = null;

  @Action
  async getContentList(params?: { category?: string; status?: string; parentId?: string; limit?: number; offset?: number; sort?: string }) {
    this.setLoading(true);
    const queryParams = new URLSearchParams();
    if (params?.category) queryParams.append('category', params.category);
    if (params?.status) queryParams.append('status', params.status);
    if (params?.parentId) queryParams.append('parentId', params.parentId);
    if (params?.limit) queryParams.append('limit', params.limit.toString());
    if (params?.offset) queryParams.append('offset', params.offset.toString());
    if (params?.sort) queryParams.append('sort', params.sort);

    const url = '/api/v1/sys/kb/content' + (queryParams.toString() ? '?' + queryParams.toString() : '');

    return ajax.get(url)
      .then(response => {
        this.context.commit('setContentList', response.data);
        this.setLoading(false);
        return response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoading(false);
        throw error;
      });
  }

  @Action
  async search(params: { query: string; category?: string; semantic?: boolean; limit?: number }) {
    this.setLoadingSearch(true);
    const queryParams = new URLSearchParams();
    queryParams.append('q', params.query);
    if (params.category) queryParams.append('category', params.category);
    if (params.semantic !== undefined) queryParams.append('semantic', params.semantic.toString());
    if (params.limit) queryParams.append('limit', params.limit.toString());

    return ajax.get(`/api/v1/sys/kb/search?${queryParams.toString()}`)
      .then(response => {
        this.context.commit('setSearchResults', response.data);
        this.setLoadingSearch(false);
        return response.data;
      })
      .catch(error => {
        AppModule.handleApiError(error);
        this.setLoadingSearch(false);
        throw error;
      });
  }

  @Action
  clearSearch() {
    this.context.commit('setSearchResults', null);
  }

  @Action
  cleanState() {
    this.context.commit('resetState');
  }

  @Mutation
  resetState() {
    this.contentList = null;
    this.searchResults = null;
    this.loading = false;
    this.loadingSearch = false;
  }

  @Mutation
  private setLoading(loading: boolean) {
    this.loading = loading;
  }

  @Mutation
  private setContentList(list: KBContentList) {
    this.contentList = list;
  }

  @Mutation
  private setLoadingSearch(loading: boolean) {
    this.loadingSearch = loading;
  }

  @Mutation
  private setSearchResults(results: KBSearchResultDto | null) {
    this.searchResults = results;
  }
}

export const SysKBContentListModule = getModule(SysKBContentList);
